import React, {Component} from 'react';
import { connect } from 'react-redux';

import { t } from 'l10n';
import Loading from 'components/Loading';

import { actionFilterMemberMessage } from 'reducers/memberMessageList';

class MessageFilter extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pending: false,
            typeAction: 'read',
        };

        this.handleFormInput = this.handleFormInput.bind(this);
    }

    handleFormInput(e) {
        const target = e.target;

        this.setState({[target.name]: target.value});
    }

    actionMessage() {
        const { typeAction } = this.state;
        const {
            onApply,
            dispatch,
            conversationIds
        } = this.props;

        const reducerParams = {
            ids: conversationIds,
            action: typeAction
        };

        this.setState({pending: true})

        let action = actionFilterMemberMessage(reducerParams);

        dispatch(action);

        action.promise
            .then(() => {
                this.setState({
                    pending: false,
                    typeAction: 'read',
                });
                onApply();
            })
            .catch((e) => this.setState({pending: false}))
    }


    render() {
        const { pending, typeAction } = this.state;
        const { trash, allCheck, conversationIds, chooseCheckAll } = this.props;

        return (
            <div className="top-block">
                <div className="top">
                    <div className="checkbox">
                        <input type="checkbox" id="check1" checked={(allCheck) ? "checked" : ""} onChange={chooseCheckAll}/>
                        <label htmlFor="check1">Selected: {conversationIds.length}</label>
                    </div>
                    <select name="typeAction" className="filter-select" value={typeAction} onChange={this.handleFormInput}>
                        <option value="read">{t('Mark as read')}</option>
                        {trash ? <option value="move-to-inbox">{t('Move to inbox')}</option> : null}
                        <option value="delete">{!trash ? t('Delete') : t('Delete permanently')}</option>
                    </select>
                    {pending ? <Loading /> : 
                        <button className="filter-apply" onClick={() => this.actionMessage()}>{t('Apply')}</button>}
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
    }),
    null
)(MessageFilter);


// WEBPACK FOOTER //
// ./src/components/message/MessageListFilter.js